import { makeAutoObservable } from "mobx";
import { fetchMockupImage } from "../services/MockupService";

class MockupStore {
  constructor(workAreaStore, errorStore, saveStore){
    makeAutoObservable(this)
    this.workAreaStore = workAreaStore
    this.errorStore = errorStore
    this.saveStore = saveStore
  }
  mockupPreview = null
  mockupSize = null
  mockupLoaded = false
  sidebarOpen = true
  mockupPreview = null
  saveLoading = false
  mockupLoading = false

  async updateMockup(initialLoad = false){
    try{
      this.mockupLoading = true
      if(!this.workAreaStore.saved){
        await this.saveStore.saveDesign(true)
      }
      const res = await fetchMockupImage(this.workAreaStore.designId, true)
      const { base64 } = res.data
      if(initialLoad){
        this.mockupLoaded = true
      }
      this.mockupPreview = base64
      this.mockupLoading = false
    }catch(err){
      this.mockupLoaded = true
      this.mockupLoading = false
      this.errorStore.setErrorMessage(err.response.data.message, true)
    }
  }

  async routeToMockupEditor(){
    try{
      this.saveLoading = true
      await this.saveStore.saveDesign(true, true)
      setTimeout(() => {
        const { mockup } = this.workAreaStore
        const url = `https://${window.location.host}/library/saved-mockups/${mockup.nr}`
        //const params = `?layerId=${mockup.mockupLayerId}&designId=${this.workAreaStore.designId}`
        const redirUrl = url
        window.location.replace(redirUrl)
        this.saveLoading = false
      }, 1250)
    }catch(err){
      this.saveLoading = false
    }
  }

  toggleSidebar(){
    this.sidebarOpen = !this.sidebarOpen
  }

}

export default MockupStore